import { Thermometer } from 'lucide-react'
import { SeriesChart, VitalChartFrame, vitalNumber } from '../VitalPlot/VitalPlot'
import '../VitalPlot/VitalPlot.css'
import './FeverCurve.css'

function formatTemp(value) {
  if (!Number.isFinite(value)) return '—'
  return `${Number(value).toFixed(1)}°C`
}

function FeverCurve({ points = [] }) {
  const series = points
    .map((point) => ({ at: point.at, value: vitalNumber(point.temperature) }))
    .filter((point) => point.value != null)
    .map((point) => ({ at: point.at, value: point.value, label: `${point.value.toFixed(1)}°` }))
  const latest = series.length ? series[series.length - 1].value : null
  const values = series.map((point) => point.value)
  const dataMin = values.length ? Math.min(...values) : 36
  const dataMax = values.length ? Math.max(...values) : 37.8
  const yMin = Math.min(35, Math.floor(dataMin))
  const yMax = Math.max(38, Math.ceil(Math.max(dataMax, 37.8)))
  const ticks = []
  for (let tick = yMin; tick <= yMax; tick += 1) ticks.push(tick)

  return (
    <VitalChartFrame
      className="fever-curve"
      icon={<Thermometer size={16} />}
      title="Curva Térmica & Monitoramento de Febre (°C)"
      badgeLabel="Temp. Atual:"
      badgeValue={formatTemp(latest)}
      legend={[
        { mark: 'is-alert', label: 'Limiar Febril (≥ 37.8°C)' },
        { mark: 'is-safe', label: 'Faixa Eutérmica (36.0 - 37.2°C)' }
      ]}
      empty={series.length === 0 ? 'Nenhuma temperatura registrada para este paciente.' : ''}
    >
      <SeriesChart
        points={series}
        yMin={yMin}
        yMax={yMax}
        ticks={ticks}
        tickLabel={(tick) => `${tick.toFixed(1)}°`}
        band={{ from: 36, to: 37.2 }}
        guides={[
          { key: 'low', value: 36, className: 'vital-guide-safe' },
          { key: 'high', value: 37.2, className: 'vital-guide-safe' },
          { key: 'fever', value: 37.8, className: 'vital-guide-alert' }
        ]}
        gradientFrom="#e11d48"
        gradientTo="#fecdd3"
        ariaLabel="Curva térmica e monitoramento de febre"
      />
    </VitalChartFrame>
  )
}

export default FeverCurve
